import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { memberApi } from '@formosa/shared/api/member';
import { ApiError } from '@formosa/shared/api/createClient';
import { resolveNewsApiLang } from '@formosa/shared/utils/newsLang';
import { useTravelTranslation } from '../app/TravelLocaleContext';
import './auth.css';

export default function LegalContentPage({ type }) {
  const navigate = useNavigate();
  const { locale } = useTravelTranslation();
  const [body, setBody] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const isAgreement = type === 'agreement';
  const title = isAgreement ? 'User Agreement' : 'Privacy Policy';

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      setError('');
      try {
        const lang = resolveNewsApiLang(locale);
        const data = isAgreement
          ? await memberApi.agreement({ lang })
          : await memberApi.privacyPolicy({ lang });
        if (!cancelled) setBody(data?.body || '');
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof ApiError ? err.message : `Unable to load ${title}`);
          setBody('');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, [isAgreement, locale, title]);

  return (
    <main className="travel-auth travel-auth--wide">
      <article className="travel-auth__card travel-auth__legal">
        <div className="travel-auth__legal-header">
          <button type="button" className="travel-auth__text-btn" onClick={() => navigate(-1)}>
            Back
          </button>
          <Link className="travel-auth__brand" to="/explore">Formosa Travel</Link>
        </div>
        <h1>{title}</h1>
        {loading ? <p className="travel-auth__hint">Loading…</p> : null}
        {error ? <div className="travel-auth__error" role="alert">{error}</div> : null}
        {!loading && !error && body ? (
          <div className="travel-auth__legal-body" dangerouslySetInnerHTML={{ __html: body }} />
        ) : null}
        {!loading && !error && !body ? (
          <p className="travel-auth__hint">No content is published for this language yet.</p>
        ) : null}
      </article>
    </main>
  );
}
